import { Component, OnDestroy, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Course }  from 'src/app/core/models/api/course.model';
import { Edition } from 'src/app/core/models/api/edition.model';

import { AreaResourceService }   from 'src/app/core/services/api/area-resource.service';
import { CourseResourceService } from 'src/app/core/services/api/course-resource.service';
import { CampusService }         from 'src/app/core/services/api/campus.service';
import { CourseService }         from 'src/app/core/services/api/course.service';

@Component({
    selector: 'app-course-detail',
    templateUrl: './course-detail.component.html',
    styleUrls: ['./course-detail.component.scss']
})
export class CourseDetailComponent implements OnInit, OnDestroy {

    private editionId : number;
    private courseUrl : string;

    course : Course;
    edition: Edition;

    courseIconPath    : string;
    courseDescription : string;
    coursePdfPath     : string;
    safeCoursePdfPath : SafeResourceUrl;
    courseRequirements: string;
    courseOnlineTechnicalRequirements: string;
    courseOnlineUserRequirements     : string;
    courseOnlineSoftwareRequirements : string;
    
    areaIconPath  : string;
    areaBadgeClass: string;

    public loadingData   : boolean = false;

    private courseSubscription : Subscription;

    constructor(
        private route: ActivatedRoute, 
        private sanitizer: DomSanitizer, 
        private campusService: CampusService,
        private courseService: CourseService,
        private areaResourceService: AreaResourceService, 
        private courseResourceService: CourseResourceService) { }

    ngOnInit(): void {

        this.loadingData = false;
        this.getCourseFromRoute();
        this.subscribeToCourseService();

    }

    ngOnDestroy() {
        
        if (this.courseSubscription && !this.courseSubscription.closed) { this.courseSubscription.unsubscribe(); }
    
    }
    
    private getCourseFromRoute() {

        this.route.paramMap.subscribe(params => {
            
            this.editionId = +params.get("editionId");
            this.edition   = this.campusService.campusActive.editions.find(c => c.editionId == this.editionId);

            this.courseUrl = params.get("courseUrl");
            this.courseService.getCourseByUrl(this.courseUrl).subscribe();

        });

    }

    private subscribeToCourseService() {

        this.courseSubscription = this.courseService.courseActiveData$.subscribe({
            next: (data) => { 
                this.course = data;
                this.getCourseResources();
                this.getAreaResources();
                this.loadingData = true;
            }
        });

    }

    getCourseResources() {

        this.courseIconPath     = this.courseResourceService.findResource(this.course.resources, 'icon-bg', this.edition.editionId);
        this.courseDescription  = this.courseResourceService.findResource(this.course.resources, 'long-description', this.edition.editionId);
        this.courseRequirements = this.courseResourceService.findResource(this.course.resources, 'requirements', this.edition.editionId);
        
        var pdfResource         = this.courseResourceService.findResource(this.course.resources, 'pdf', this.edition.editionId);
        this.coursePdfPath      = pdfResource ? window.location.origin + '/' +  pdfResource : null;
        this.safeCoursePdfPath  = this.coursePdfPath ? this.getSafeResourceURL(this.coursePdfPath) : null;
        
        this.courseOnlineTechnicalRequirements = this.courseResourceService.findResource(this.course.resources, 'technical-requirements', this.edition.editionId);
        this.courseOnlineUserRequirements      = this.courseResourceService.findResource(this.course.resources, 'user-requirements', this.edition.editionId);
        this.courseOnlineSoftwareRequirements  = this.courseResourceService.findResource(this.course.resources, 'software-requirements', this.edition.editionId);
        
    }
    
    getAreaResources() {

        this.areaBadgeClass = this.areaResourceService.findResource(this.course.area.resources, 'badge-class');
        this.areaIconPath   = this.areaResourceService.findResource(this.course.area.resources, 'icon');
        
    }

    getSafeResourceURL(url: string) {

        return this.sanitizer.bypassSecurityTrustResourceUrl(url);

    }

}
